// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"MultiWithBadges_checkboxContainer__CFMmx","badgeContainer":"MultiWithBadges_badgeContainer__WayZr","closeableBadge":"MultiWithBadges_closeableBadge__5nFMF"};